export default __webpack_public_path__ + "static/media/042-radiation.2e29e8a9.png";